import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { MatSelectChange } from '@angular/material/select'
import { ResultCode } from '../../../domain/authentication.model'
import { BeatsSortBy } from '../../../enums/enums'
import { AppService } from '../../../services/prod/app.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { ProducerManagementService } from '../../../services/producer-management.service'
import { UploadImageResultType, UploadImageStatusType } from '../../../types/common.type'

@Component({
  selector: 'bmcore-rating-tracks-select',
  templateUrl: './bmcore-rating-tracks-select.component.html',
  styleUrls: ['./bmcore-rating-tracks-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreRatingTracksSelectComponent implements OnInit {
  lg: LgType
  BeatsSortBy = BeatsSortBy
  defaultBeatsSorting: BeatsSortBy = BeatsSortBy.OrderNumber
  responseMessage: UploadImageResultType = {
    status: 'idle',
    message: ''
  }

  constructor(
    private i18nService: I18nService,
    private producerManagementService: ProducerManagementService,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.getDefaultBeatSorting()
  }

  getDefaultBeatSorting() {
    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res?.beatmakerId) {
        this.defaultBeatsSorting = res.defaultBeatsSorting
      }
    })
  }

  sortTracks(event: MatSelectChange) {
    this.defaultBeatsSorting = event.value
    this.producerManagementService.changeDefaultBeatsSorting(this.defaultBeatsSorting).subscribe(
      res => {
        if (res.resultCode === ResultCode.Success) {
          window.location.reload()
          // this.setResponseMessage('success', this.lg.colorCustomizer.defaultBeatsSortingBlock.successMessage);
        } else {
          this.setResponseMessage('error', res.messages[0])
        }
      },
      err => this.setResponseMessage('error', err.message)
    )
  }

  setResponseMessage(status: UploadImageStatusType, message: string) {
    this.responseMessage = {
      status,
      message
    }
  }
}
